<template>
    <div  v-if="loaded">
        <section v-if="!expired" class="d-flex align-items-center justify-center text-center bg-danger text-white">
            <div class="p-3 days mr-2 relative">
                <div class="h1">{{displayDays}}</div>
                <div class="text-sm absolute bottom-0">Dias</div>
            </div>
            <span class="h1 leading-snug">:</span>
            <div class="p-3 hours mx-2 relative">
                <div class="h1">{{displayHours}}</div>
                <div class="text-sm absolute bottom-0">Horas</div>
            </div>
            <span class="h1 leading-snug">:</span>
            <div class="p-3 minutes mx-2 relative">
                <div class="h1">{{displayMinutes}}</div>
                <div class="text-sm absolute bottom-0">Minutos</div>
            </div>
            <span class="h1 leading-snug">:</span>
            <div class="p-3 seconds ml-2 relative">
                <div class="h1">{{displaySeconds}}</div>
                <div class="text-sm absolute bottom-0">Segundos</div>
            </div>
        </section>

        <div :class="(!expired) ? 'alert alert-custom alert-light-success fade show' : 'alert alert-custom alert-light-danger fade show'" role="alert">
            <div class="alert-icon"><i class="el-icon-message-solid icon-3x"></i></div>
            <div class="alert-text font-weight-bolder" v-text="(!expired)? 'Inscripciones habilitadas' : 'Inscripciones Finalizadas'"></div>
            <div class="alert-close">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                    <span aria-hidden="true"><i class="ki ki-close"></i></span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props:["enddate"],
    data: () => ({
        displayDays: 0,
        displayHours: 0,
        displayMinutes: 0,
        displaySeconds: 0,
        loaded: false,
        expired: false
    }),
    computed: {
        _seconds: () => 1000,
        _minutes() {
            return this._seconds * 60;
        },
        _hours() {
            return this._minutes * 60;
        },
        _days(){
            return this._hours * 24;
        },
        end(){
            return new Date(this.enddate);
        }
    },
    mounted(){
        this.showRemaining();
    },
    methods: {
        formatNum: num => (num < 10 ? "0" + num : num),

        showRemaining(){
            const timer = setInterval(() => {
                const now = new Date();
                //const end = new Date(2021, 4, 20, 10, 10, 10, 10);
                const distance = this.end.getTime() - now.getTime();

                if(distance < 0 ){
                    clearInterval(timer);
                    this.expired = true;
                    this.loaded = true;
                    return;
                }

                const days = Math.floor(distance / this._days);
                const hours = Math.floor((distance % this._days) / this._hours);
                const minutes = Math.floor((distance % this._hours) / this._minutes);
                const seconds = Math.floor((distance % this._minutes) / this._seconds);

                this.displayMinutes = this.formatNum(minutes);
                this.displaySeconds = this.formatNum(seconds);
                this.displayHours = this.formatNum(hours);
                this.displayDays = this.formatNum(days); 

                this.loaded = true;
            }, 100);
        }
    }
}
</script>